import PrimaryButton from "components/buttons/primary-button";
import Modal from "components/modal";
import TakedownVideoModal from "components/modal/modals/takedown-video-modal";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";

const VideoOptions = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const navigate = useNavigate();
  return (
    <Container>
      <PrimaryButton
        text="Download"
        icon={
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="100%"
            height="100%"
            viewBox="0 0 20 20"
            fill="none"
          >
            <path
              d="M2.5 12.5C2.5 14.857 2.5 16.0355 3.23223 16.7677C3.96447 17.5 5.14297 17.5 7.5 17.5H12.5C14.857 17.5 16.0355 17.5 16.7677 16.7677C17.5 16.0355 17.5 14.857 17.5 12.5"
              stroke="#131313"
              stroke-width="1.25"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M9.99935 2.5V13.3333M9.99935 13.3333L13.3327 9.6875M9.99935 13.3333L6.66602 9.6875"
              stroke="#131313"
              stroke-width="1.25"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        }
        iconSize="2"
        iconPosition="right"
      />
      <PrimaryButton
        text="View RAted Fans Link"
        variant="p-fade"
        onClick={() => navigate("/video-share/1")}
        icon={
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
          >
            <path
              d="M11.666 10C11.666 12.7614 9.42743 15 6.66602 15C3.90459 15 1.66602 12.7614 1.66602 10C1.66602 7.23857 3.90459 5 6.66602 5"
              stroke="#FEA101"
              stroke-width="1.25"
              stroke-linecap="round"
            />
            <path
              d="M8.33398 10C8.33398 7.23857 10.5726 5 13.334 5C16.0954 5 18.334 7.23857 18.334 10C18.334 12.7614 16.0954 15 13.334 15"
              stroke="#FEA101"
              stroke-width="1.25"
              stroke-linecap="round"
            />
          </svg>
        }
        iconPosition="right"
        iconSize="2"
      />
      <PrimaryButton
        onClick={() => setIsModalOpen(true)}
        variant="d-fade"
        icon={
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="100%"
            height="100%"
            viewBox="0 0 20 20"
            fill="none"
          >
            <path
              d="M17.0828 5H2.91602"
              stroke="#FF3333"
              stroke-width="1.25"
              stroke-linecap="round"
            />
            <path
              d="M15.6936 7.0835L15.3103 12.8327C15.1628 15.0452 15.089 16.1514 14.3682 16.8257C13.6474 17.5002 12.5387 17.5002 10.3214 17.5002H9.67694C7.45956 17.5002 6.3509 17.5002 5.63005 16.8257C4.90922 16.1514 4.83547 15.0452 4.68797 12.8327L4.30469 7.0835"
              stroke="#FF3333"
              stroke-width="1.25"
              stroke-linecap="round"
            />
            <path
              d="M7.91602 9.1665L8.33268 13.3332"
              stroke="#FF3333"
              stroke-width="1.25"
              stroke-linecap="round"
            />
            <path
              d="M12.0827 9.1665L11.666 13.3332"
              stroke="#FF3333"
              stroke-width="1.25"
              stroke-linecap="round"
            />
            <path
              d="M5.41602 5C5.46258 5 5.48587 5 5.50697 4.99947C6.19317 4.98208 6.79853 4.54576 7.03203 3.90027C7.03922 3.88041 7.04657 3.85833 7.0613 3.81414L7.14221 3.57142C7.21127 3.36423 7.24581 3.26063 7.29161 3.17267C7.47436 2.82172 7.81247 2.57803 8.20319 2.51564C8.30112 2.5 8.41035 2.5 8.62877 2.5H11.3699C11.5883 2.5 11.6976 2.5 11.7955 2.51564C12.1863 2.57803 12.5243 2.82172 12.7071 3.17267C12.7529 3.26063 12.7874 3.36423 12.8565 3.57142L12.9374 3.81414C12.9521 3.85827 12.9595 3.88042 12.9667 3.90027C13.2002 4.54576 13.8055 4.98208 14.4918 4.99947C14.5128 5 14.5361 5 14.5827 5"
              stroke="#FF3333"
              stroke-width="1.25"
            />
          </svg>
        }
        iconPosition="center"
        iconSize="2"
      />
      <Modal closeModal={() => setIsModalOpen(false)} isActive={isModalOpen}>
        <TakedownVideoModal
          closeModal={() => setIsModalOpen(false)}
          confirm={() => {}}
          name="Blueberry Faygo"
        />
      </Modal>
    </Container>
  );
};

export default VideoOptions;

const Container = styled.div`
  display: grid;
  grid-template-columns: auto auto auto;
  grid-column-gap: 0.8rem;
`;
